<template>
	<div class="grid__content">
        <scrollbar class="blog">
            <div class="blog-wrap">
                <div class="blog-title-wrap">
                    <div class="blog-autor">
                            <div class="blog-autor-avatar f-ava"><img src="../../assets/img/adenisov.png" class="f-ava__img"></div>
                            <div class="blog-autor-name">Алексей Денисов<p>Управляющий трейдер</p>
                            </div>
                    </div>
                    <div class="blog-title">
                        Блог
                    </div>
                </div>
                <div class="blog-button-wrap">
                    <div class="blog-button-block">
                        <div
                            :class="item.status ? 'blog-button-block-item blog-button-block-item-active' : 'blog-button-block-item'"
                            v-for="(item,index) in favotiteCategory" :key="index"
                            @click="setCategory(item.category,index)">{{item.title}}
                            </div>
                        <div class="blog-button-block-item"><i class="mdi mdi-dots-horizontal"></i></div>
                    </div>
                    <!--<div class="blog-button-block">
                        <div class="blog-button-block-item-single">За все время <i class="mdi mdi-chevron-down"></i></div>
                    </div>-->
                </div>
                <!--<div class="blog-new_aticle">Новая статья</div>-->
                <articles :category="category"></articles>
            </div>
        </scrollbar>
        </div>
</template>

<script>
import BlogArticles from './sig-blog-articles'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
	export default {
		components: {
            'articles':BlogArticles,
            'scrollbar':VuePerfectScrollbar
	    },
		props: [],
		data() {
			return {
                category: 'all',
                favotiteCategory: [
                    {
                        title:'Все',
                        category:'all',
                        status:true
                    },
                    {
                        title:'EUR/USD',
                        category:'EURUSD',
                        status:false
                    },
                    {
                        title:'GBP/USD',
                        category:'GBPUSD',
                        status:false
                    },
                    {
                        title:'USD/JPY',
                        category:'USDJPY',
                        status:false
                    },
                    {
                        title:'USD/CHF',
                        category:'USDCHF',
                        status:false
                    },
                    {
                        title:'AUD/USD',
                        category:'AUDUSD',
                        status:false
                    },
                    {
                        title:'EUR/GBP',
                        category:'EURGBP',
                        status:false
                    },
                    {
                        title:'NZD/USD',
                        category:'NZDUSD',
                        status:false
                    },
                    {
                        title:'USDCAD',
                        category:'USD/CAD',
                        status:false
                    },
                ]
			};
		},
		computed: {

		},
		methods: {
			setCategory(category, index) {
                this.category = category;
                for(let i = 0; i < this.favotiteCategory.length; i++)
                {
                    this.favotiteCategory[i].status = false
                    this.favotiteCategory[index].status = true;
                }
            }
		}

	};
</script>

<style lang="less" scoped>
.blog
{
    width: 100%;
    position: relative;
    &-wrap {
         display: flex;
        flex-direction: column;
        align-items: center;
        width: 912px;
        margin: 0 auto;
        position: relative;
    }
    &-title
    {
        font-family: Montserrat;
        font-size: 23px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.09;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #ffffff;
        width: 100%;
        text-align: center;

        &-wrap
        {
            position: relative;
            margin-top: 40px;
            width: 100%;
        }
    }

    &-autor
    {
        display: flex;
        width: 100%;
        position: absolute;
        align-items: center;

        &-avatar {
            margin-right: 16px;
        }

        &-name
        {
            font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.54;
            letter-spacing: 0.4px;
            text-align: left;
            color: #ffffff;
            text-transform: none;

            p
            {
                color:#a1b7cc;
            }
        }
    }

    &-button
    {
        &-wrap
        {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 40px;
            font-family: Montserrat;
            font-size: 14px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.43;
            letter-spacing: 0.4px;
            color: #adc7e1;
        }

        &-block
        {
            display: flex;
            &-item
            {
                padding: 0 17px 0 20px;
                border: solid 1px #3d536b;
                cursor: pointer;
                margin-left: -1px;

                &:first-child
                {
                    padding: 0 20px;
                    border-radius: 4px 0 0 4px;
                    border: solid 1px #3d536b;
                    cursor: pointer;

                    &:hover
                    {
                        background: #3d536b;
                        color: #cae9ff;
                    }
                }

                &:last-child
                {
                    padding: 0 20px;
                    border-radius: 0 4px 4px 0;
                    border: solid 1px #3d536b;
                    cursor: pointer;

                }

                span
                {
                    color:#fff;
                    margin-left: 12px;
                }

                &:hover
                {
                    background: #3d536b;
                    color: #cae9ff;
                }

                &-active {
                    background: #fff;
                    border: solid 1px #fff;
                    color: #293546;

                    &:hover {
                        background: #fff;
                        border: solid 1px #fff;
                        color: #293546;
                    }
                }

                &-single
                {
                    padding: 0 20px;
                    border-radius: 4px;
                    border: solid 1px #3d536b;
                    cursor: pointer;

                    i
                    {
                        margin-left: 27px;
                    }

                     &:hover
                    {
                        background: #3d536b;
                        color: #cae9ff;
                    }
                }
            }

        }
    }

    &-new_aticle
    {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 4.36;
        letter-spacing: 0.4px;
        text-align: center;
        color: #adc7e1;
        text-transform: uppercase;
        border-radius: 4px;
        background-color: #324258;
        width: 100%;
        margin-top: 40px;
    }

}
</style>
